export default __webpack_public_path__ + "static/media/more-vertical.f0d396e4.svg";